import { Breadcrumb, Menu } from "antd"
import { useMemo } from "react"
import { Outlet, useMatch, useNavigate } from "react-router-dom"
import styles from './index.module.less'
import * as AdminService from "@/services/admin/property-set"
import { OrganizationPropertySetService } from "@/services/admin/property-set"
import { useRequest } from "ahooks"

interface PropertySetProps {
  orgId?: number
}

export function PropertySet(props: PropertySetProps) {
  const { orgId } = props
  const navigate = useNavigate()
  // Admin path: /admin/property-sets/:id/:key
  // Org path: /organizations/:orgId/physical-properties/property-sets/:id/:key
  
  // We can't rely on fixed match pattern if path differs structure.
  // But usually params are available if route is defined with :id.
  // Let's use useLocation or just assume last segments?
  
  // Better approach: regex match or multiple useMatch?
  const adminMatch = useMatch('/admin/property-sets/:id/:key')
  const orgMatch = useMatch('/:orgId/physical-properties/property-sets/:id/:key')
  
  const match = orgId ? orgMatch : adminMatch
  
  const activeKey = useMemo(() => match?.params.key || 'basic', [match])
  const id = match?.params.id
  console.log('id', id)
  
  const service = useMemo(() => {
      if (orgId) {
          return {
              getPropertySet: (id) => OrganizationPropertySetService.getPropertySet(id),
              createPropertySet: (body) => OrganizationPropertySetService.createPropertySet(orgId, body),
              updatePropertySet: (id, body) => OrganizationPropertySetService.updatePropertySet(id, body)
          }
      }
      return AdminService
  }, [orgId])

  const {data: propertySet, refresh } = useRequest(() => {
    if (!id || isNaN(Number(id))) {
      return Promise.resolve(null);
    }
    return service.getPropertySet(Number(id))
  }, {
      refreshDeps: [service, id, orgId]
  })

  const propertySetMenus = [
    {
      key: 'basic',
      label: 'Basic',
    },
    {
      key: 'components',
      label: 'Components',
      disabled: !propertySet
    },
    {
      key: 'reactions',
      label: 'Reactions',
      disabled: !propertySet
    },
    {
      key: 'reaction-sets',
      label: 'Reaction Sets',
      disabled: !propertySet
    },
  ]

  const onSave = async (body) => {
    if (propertySet) {
      await service.updatePropertySet(Number(id), body)
      refresh()
    } else {
      const res = await service.createPropertySet(body)
      navigate(`../${res.id}/basic`, { replace: true })
    }
    
  }

  const onCancel = async () => {
    navigate(`../`)
  }

  return <div>
    <Breadcrumb>
      <Breadcrumb.Item>Property Sets</Breadcrumb.Item>
      <Breadcrumb.Item>{propertySet ? propertySet.name: 'Create'}</Breadcrumb.Item>
    </Breadcrumb>
    <div className={styles.container}>
      <Menu
        style={{width: 140}}
        activeKey={activeKey}
        items={propertySetMenus}
        onSelect={({ key }) => {
          navigate(`../${key}`)
        }}
      />
      <div className={styles.content}>
        <Outlet context={{propertySet, onSave, onCancel, refresh, orgId}} />
      </div>
    </div>
  </div>
}